export default '/opt/acquisit-runner/_work/acquisit/acquisit/node_modules/pdfkit/js'